import { render, staticRenderFns } from "./newAdressChange.vue?vue&type=template&id=811bc70e&scoped=true&"
import script from "./newAdressChange.vue?vue&type=script&lang=js&"
export * from "./newAdressChange.vue?vue&type=script&lang=js&"
import style0 from "./newAdressChange.vue?vue&type=style&index=0&id=811bc70e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811bc70e",
  null
  
)

export default component.exports